import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "inner-modal inner-modal--dff" }
const _hoisted_2 = { class: "dff" }
const _hoisted_3 = { class: "dff__inner" }

import {computed, ref} from 'vue';
import jsonData from 'Data/doorfitfinder.json';
import DFFQuestion from 'Vue/components/lockDesigner/components/DFFQuestion.vue';
import DFFIntro from 'Vue/components/lockDesigner/components/DFFIntro.vue';
import DFFLoading from 'Vue/components/lockDesigner/components/DFFLoading.vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const questions = jsonData.questions;
const componentName = 'DoorFitFinderModal';
const store = useStore();

const activeComponent = computed(() => {
	return store?.state?.doorFitFinder?.activeComponent;
});

const generateRef = (id) => {
	return ref(id);
};
const activeQuestion = (id) => {
	return store?.state?.doorFitFinder?.activeQuestion === id;
};

const closeModal = () => {
	store.dispatch('closeModal');
	store.commit('resetDoorFitFinderSelections', {
		activeComponent: "intro",
		prevQuestion: "",
		activeQuestion: "Q1",
		existingHardware: "",
		lock: null,
		doorEdge: ""
	})
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(activeComponent) === 'intro')
          ? (_openBlock(), _createBlock(DFFIntro, { key: _unref(activeComponent) }))
          : _createCommentVNode("v-if", true),
        (_unref(activeComponent) === 'questions')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(questions), (q) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: q.id
              }, [
                (activeQuestion(q.id))
                  ? (_openBlock(), _createBlock(DFFQuestion, {
                      key: 0,
                      questionref: generateRef(q.id),
                      questionobject: q,
                      question: q.question,
                      answers: q.answers
                    }, null, 8 /* PROPS */, ["questionref", "questionobject", "question", "answers"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (_unref(activeComponent) === 'loading')
          ? (_openBlock(), _createBlock(DFFLoading, { key: _unref(activeComponent) }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("button", {
      onClick: closeModal,
      class: "inner-modal__close"
    }, "×")
  ]))
}
}

})